import { createException, ExceptionsTypes } from './utilities/Exceptions';
import NetworkRequest from './utilities/NetworkRequest';
import { validateRequest } from './utilities/validators';

const config = NetworkRequest.configureDAF;

export default async function requestApi(request) {
  const { type } = request;

  if (validateRequest(request)) {
    try {
      const networkCallerInstance = NetworkRequest.getNetworkUrl(request.url);
      const data = await networkCallerInstance({
        ...request,
        data: request.data ? request.data : null,
        method: type.toLowerCase(),
      });
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  } else {
    return Promise.reject(
      createException(
        ExceptionsTypes.BadRequest,
        `Invalid request passed to execute method type: ${request}.`,
      ),
    );
  }
}

export { requestApi, config };
